import React from "react";
import { StyleSheet, View } from "react-native";
import Utils from "../../../../../helpers/utils";

export default function CurrentTimeIndicator({
  timeslot,
  editMode,
  today,
  time,
}) {
  const currentTimeOffset = Utils.getTimeIndex(today, time, timeslot);

  return (
    <>
      {!editMode && currentTimeOffset > 0 && currentTimeOffset <= 100 && (
        <>
          <View
            pointerEvents="none"
            style={[
              styles.currentTimeIndicator,
              { top: `${currentTimeOffset}%` },
            ]}
          />
        </>
      )}
    </>
  );
}

const styles = StyleSheet.create({
  currentTimeIndicator: {
    borderWidth: 1,
    borderStyle: "dashed",
    borderColor: "#925BE8",
    position: "absolute",
    left: 30,
    right: 0,
    zIndex: 10,
  },
});
